import React from "react";

/**
 * Lightweight inline-SVG bar chart. No external chart library — keeps bundle small.
 * Pass `series` as `[{date, revenue, orders}]`.
 */
const RevenueChart = ({ series, height = 180 }) => {
  if (!series || series.length === 0) {
    return (
      <div className="text-center py-10 text-sm text-gray-400" data-testid="revenue-chart-empty">
        No revenue yet — once orders come in, your daily trend will appear here.
      </div>
    );
  }
  const W = 800;
  const H = height;
  const padX = 24;
  const padY = 24;
  const max = Math.max(1, ...series.map((d) => d.revenue));
  const barW = (W - padX * 2) / series.length - 4;

  return (
    <div className="overflow-x-auto" data-testid="revenue-chart">
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-[180px] min-w-[600px]">
        <line x1={padX} x2={W - padX} y1={H - padY} y2={H - padY} stroke="#e5e7eb" strokeWidth="1" />
        <line x1={padX} x2={W - padX} y1={padY} y2={padY} stroke="#f1f5f9" strokeWidth="1" strokeDasharray="2 4" />
        {series.map((d, i) => {
          const x = padX + i * (barW + 4);
          const h = ((d.revenue / max) * (H - padY * 2)) || 0;
          const y = H - padY - h;
          const isLast = i === series.length - 1;
          return (
            <g key={d.date}>
              <rect
                x={x}
                y={y}
                width={barW}
                height={h}
                fill={isLast ? "#b91c1c" : "#0a0a0a"}
                opacity={d.revenue > 0 ? 0.9 : 0.1}
              >
                <title>{`${d.date} · $${d.revenue.toFixed(2)} · ${d.orders} order${d.orders === 1 ? "" : "s"}`}</title>
              </rect>
            </g>
          );
        })}
      </svg>
      <div className="flex justify-between text-[10px] text-gray-400 mt-1 px-6 uppercase tracking-[0.14em]">
        <span>{series[0].date}</span>
        <span>{series[series.length - 1].date}</span>
      </div>
    </div>
  );
};

export default RevenueChart;
